import { RoutesConst } from './const-routes';

export interface BreadcrumbLevel {
  link: RoutesConst;
  localizationKey: string;  // this key will be used for localization
  dataCy: string;
}

export interface BreadcrumbLevelLocalized extends BreadcrumbLevel {
  localizedTitle: string;
}

const publicCbsaHomeLevel = {
  link: RoutesConst.CBSAPublicHome,
  localizationKey: 'breadcrumb.home'} as BreadcrumbLevel;

const publicCbsaClientPortalLevel = {
  link: RoutesConst.PublicHome,
  localizationKey: 'breadcrumb.clientportal'} as BreadcrumbLevel;

const publicHomeLevel = {
  link: RoutesConst.PublicHome,
  dataCy: 'home-breadcrumb',
  localizationKey: 'breadcrumb.home'} as BreadcrumbLevel;

const publicCarmApiLevel = {
  link: RoutesConst.PublicCarmApi,
  localizationKey: 'breadcrumb.carm-api-home'} as BreadcrumbLevel;

const publicOnboardingDocumentationLevel = {
  link: RoutesConst.PublicCarmApi,
  localizationKey: 'breadcrumb.onboarding-documentation'} as BreadcrumbLevel;

const privateDashBoardLevel = {
  link: RoutesConst.Dashboard,
  dataCy: 'dashboard-breadcrumb',
  localizationKey: 'breadcrumb.home'} as BreadcrumbLevel;

const businessRegistrationStatusLevel = {
  link: RoutesConst.PortalRegistrationStatus,
  localizationKey: 'breadcrumb.home'} as BreadcrumbLevel;

const businessRegistrationFirstTimeSetup = {
  link: RoutesConst.AccountProfile_FirstTimeSetup,
  localizationKey: 'breadcrumb.home'} as BreadcrumbLevel;

const accountsAndProfilesLevel = {
  link: RoutesConst.AccountProfile,
  localizationKey: 'breadcrumb.accountsAndProfiles.main'} as BreadcrumbLevel;

const accountsAndProfilesAddressLevel = {
  link: RoutesConst.AccountProfile_BusinessProfile_Addresses,
  localizationKey: 'view_personal_profile.address_label'} as BreadcrumbLevel;

const accountsAndProfilesContactsLevel = {
  link: RoutesConst.AccountProfile_BusinessProfile_Contacts,
  localizationKey: 'program_account.business_profile.details.contacts.title'} as BreadcrumbLevel;

const programAccountAddressLevel = {
  link: RoutesConst.AccountProfile_ProgramAccount_Addresses,
  localizationKey: 'view_personal_profile.address_label'} as BreadcrumbLevel;

const programAccountContactsLevel = {
  link: RoutesConst.AccountProfile_ProgramAccount_Contacts,
  localizationKey: 'program_account.business_profile.details.contacts.title'} as BreadcrumbLevel;

const accountsAndProfilesLevelSubPrograms = {
  link: RoutesConst.AccountProfile_ProgramAccount_SubPrograms,
  localizationKey: 'breadcrumb.listOfSubProgramAccounts'} as BreadcrumbLevel;

const accountsAndProfilesLevelRequests = {
  link: RoutesConst.AccountProfile_ProgramAccount_Requests,
  localizationKey: 'breadcrumb.accountsAndProfiles.listOfProgramRequests'} as BreadcrumbLevel;

const accountsAndProfilesProgramRequestsListLevel = {
  link: RoutesConst.CbsaProgramEnrolments_Requests,
  localizationKey: 'breadcrumb.accountsAndProfiles.listOfProgramRequests'} as BreadcrumbLevel;

const programLicencesLevel = {
  link: RoutesConst.AccountProfile_ProgramAccount_ProgramLicences,
  localizationKey: 'breadcrumb.programLicences.main'} as BreadcrumbLevel;

const rulingsLevel = {
  link: RoutesConst.Rulings,
  localizationKey: 'breadcrumb.rulings.main'} as BreadcrumbLevel;

const manageClientGroupsLevel = {
  link: RoutesConst.ClientGroups,
  localizationKey: 'breadcrumb.clientGroups'} as BreadcrumbLevel;

const manageUserRequestsLevel = {
  link: RoutesConst.EmployeeAccessMgt_ManageAccessRequests,
  localizationKey: 'breadcrumb.manageRequests'} as BreadcrumbLevel;

const manageEmployeesLevel = {
  link: RoutesConst.EmployeeAccessMgt_ManageEmployees,
  localizationKey: 'breadcrumb.manageEmployees'} as BreadcrumbLevel;

const manageBusinessRelationshipsLevel = {
  link: RoutesConst.BusinessAccessMgt_ManageBusiness,
  localizationKey: 'breadcrumb.manageBusinessRelationships'} as BreadcrumbLevel;

const manageBusinessReceivedRequestsLevel = {
  link: RoutesConst.BusinessAccessMgt_B2BReceivedRequests,
   localizationKey: 'breadcrumb.manageBusinessReceivedRequests'} as BreadcrumbLevel;

const manageBusinessSentRequestsLevel = {
  link: RoutesConst.BusinessAccessMgt_B2BSentRequests,
  localizationKey: 'breadcrumb.manageBusinessSentRequests'} as BreadcrumbLevel;

const rulingsRequestsLevel = {
  link: RoutesConst.Rulings_RulingsRequests,
  localizationKey: 'breadcrumb.rulings.requests'} as BreadcrumbLevel;

const rulingsEnforcementsLevel = {
  link: RoutesConst.Enforcement_Actions,
  localizationKey: 'breadcrumb.rulings.enforcements'} as BreadcrumbLevel;

const rulingsDisenrolmentAndComplianceLevel = {
  link: RoutesConst.Compliance_Verification,
  localizationKey: 'breadcrumb.rulings.disenrolmentAndCompliance'} as BreadcrumbLevel;

const rulingsAppealsLevel = {
  link: RoutesConst.Appeals_List,
  localizationKey: 'breadcrumb.rulings.appeals'} as BreadcrumbLevel;

const linkBusinessRequirementsLevel = {
  link: RoutesConst.LinkBusiness,
  localizationKey: 'breadcrumb.linkBusinessRequirements'} as BreadcrumbLevel;

const linkBusinessNumberLevel = {
  link: RoutesConst.LinkBusiness_ValidateNumber,
  localizationKey: 'breadcrumb.linkBusinessNumber'} as BreadcrumbLevel;

const linkBusinessNameLevel = {
  link: RoutesConst.LinkBusiness_ValidateNumber,
  localizationKey: 'breadcrumb.linkBusinessName'} as BreadcrumbLevel;

const linkBusinessTransactionLevel = {
  link: RoutesConst.LinkBusiness_ValidateBusinessTransactions,
  localizationKey: 'breadcrumb.linkBusinessTransactions'} as BreadcrumbLevel;

const financialLevel = {
    link: RoutesConst.Financial,
    localizationKey: 'breadcrumb.financial.main'} as BreadcrumbLevel;

const financialSecurityLevel = {
  link: RoutesConst.Financial_FinancialSecurity,
  localizationKey: 'breadcrumb.financial.financialSecurity' } as BreadcrumbLevel;

const transactionHistoryLevel = {
  link: RoutesConst.Financial_TransactionHistory,
  localizationKey: 'breadcrumb.financial.transactionHistory' } as BreadcrumbLevel;

const notificationListLevel = {
  link: RoutesConst.Notifications_List,
  localizationKey: 'breadcrumb.notifications.list'} as BreadcrumbLevel;

const paymentsLevel = {
  link: RoutesConst.Payments,
  localizationKey: 'breadcrumb.payments.main'} as BreadcrumbLevel;

const onlinePaymentsLevel = {
  link: RoutesConst.Payments_Online_Payment,
  localizationKey: 'breadcrumb.payments.onlinePayments'} as BreadcrumbLevel;
  

const declarationsLevel = {
    link: RoutesConst.Declarations,
    localizationKey: 'breadcrumb.declarations.main'} as BreadcrumbLevel;

const createDeclarationsLevel = {
  link: RoutesConst.Declarations_Mgt_NewDeclarations,
  localizationKey: 'breadcrumb.declarations.new'} as BreadcrumbLevel;

const createTempImportLevel = {
  link: RoutesConst.Declarations_Mgt_New_Temp_Import,
  localizationKey: 'breadcrumb.temporaryImportation.create'} as BreadcrumbLevel;

  const createMasterProvisionalLevel = {
    link: RoutesConst.Master_Provisional_New,
    localizationKey: 'breadcrumb.masterProvisional.create'} as BreadcrumbLevel;

const convertDeclarationsLevel = {
  link: RoutesConst.Declarations_ConvertB3_Search,
  localizationKey: 'breadcrumb.declarations.convert'} as BreadcrumbLevel;

const declarationsListSubmittedLevel = {
  link: RoutesConst.Declarations_List_Submitted,
  localizationKey: 'breadcrumb.declarations.listSubmitted'} as BreadcrumbLevel;

const declarationsListSubmittedDraftsLevel = {
  link: RoutesConst.Declarations_List_Submitted_Declaration_Drafts,
  localizationKey: 'breadcrumb.declarations.listSubmittedDrafts'} as BreadcrumbLevel;

const declarationsDrawbackListSubmittedLevel = {
  link: RoutesConst.Declarations_List_Submitted_DutyDrawbacks,
  localizationKey: 'breadcrumb.dutyDrawbacks.main'} as BreadcrumbLevel;

const declarationsTempListSubmittedLevel = {
  link: RoutesConst.Temp_Imports_List_Submitted,
  localizationKey: 'breadcrumb.temporaryImportation.listSubmitted'} as BreadcrumbLevel;

const preAuthorizedDebitLevel = {
  link: RoutesConst.Payments_PreAuthorizedDebit,
  localizationKey: 'breadcrumb.payments.preAuthorizedDebit'} as BreadcrumbLevel;

const paymentArrangementLevel = {
  link: RoutesConst.Payments_Arrangement,
  localizationKey: 'breadcrumb.payments.arrangements'} as BreadcrumbLevel;

const publicRulingsLevel = {
  link: RoutesConst.PublicNationalRulings,
  localizationKey: 'breadcrumb.advancedNatRulings'} as BreadcrumbLevel;

const dutyDrawbacksEXPLevel = {
  link: RoutesConst.Dutydrawbacks_Main,
  localizationKey: 'breadcrumb.dutyDrawbacks.exporter'} as BreadcrumbLevel;

const massAdjustmentsLevel = {
  link: RoutesConst.MassAdjustments_Main,
  localizationKey: 'breadcrumb.massAdjustments.main'} as BreadcrumbLevel;

const massAdjustmentsListSubmittedLevel = {
  link: RoutesConst.MassAdjustments_List_Submitted,
  localizationKey: 'breadcrumb.massAdjustments.listSubmitted'} as BreadcrumbLevel;

const ROIListSubmittedLevel = {
  link: RoutesConst.Declarations_List_Submitted_Roi,
  localizationKey: 'breadcrumb.roi.listSubmitted'} as BreadcrumbLevel;

const massAdjustmentsNewOrEditLevel = {
  link: RoutesConst.MassAdjustments_NewOrEdit,
  localizationKey: 'breadcrumb.massAdjustments.newOrEdit'} as BreadcrumbLevel;

const appealsLevel = {
  link: RoutesConst.Appeals_List,
  localizationKey: 'breadcrumb.appeals'} as BreadcrumbLevel;

const complianceLevel = {
  link: RoutesConst.Compliance_Verification,
  localizationKey: 'breadcrumb.compliance'} as BreadcrumbLevel;

const statementsOfAdjustmentLevel = {
  link: RoutesConst.Statements_Of_Adjustment_List,
  localizationKey: 'breadcrumb.statements_of_adjustment'} as BreadcrumbLevel;

  const sdaLevel = {
    link: RoutesConst.Declarations_SDA_Main,
    localizationKey: 'breadcrumb.sda'} as BreadcrumbLevel;

export const Breadcrumbs = {

  PublicHome: [publicHomeLevel],
  CBSAHome: [publicCbsaHomeLevel],
  LogOut: [publicCbsaHomeLevel, publicCbsaClientPortalLevel],
  PublicHome_CarmApi: [publicCbsaHomeLevel, publicCbsaClientPortalLevel, publicCarmApiLevel],
  PublicHome_PublicRulings: [publicCbsaHomeLevel, publicCbsaClientPortalLevel, publicRulingsLevel],
  PublicHome_Onboarding_Documentation: [publicCbsaHomeLevel, publicCbsaClientPortalLevel, publicOnboardingDocumentationLevel],

  // index components
  Accounts: [privateDashBoardLevel],
  UserProfile: [privateDashBoardLevel],
  UserProfileOrphan: [businessRegistrationStatusLevel],
  Declarations_Main: [privateDashBoardLevel],
  Finance: [privateDashBoardLevel],
  Payments: [privateDashBoardLevel],
  Appeals: [privateDashBoardLevel, rulingsLevel, appealsLevel],
  compliance: [privateDashBoardLevel, rulingsLevel, complianceLevel],
  StatementsOfAdjustment: [privateDashBoardLevel, declarationsLevel],
  StatementsOfAdjustmentChild: [privateDashBoardLevel, declarationsLevel, statementsOfAdjustmentLevel],

  // Business Access Management breadcrumbs
  BusinessAccessMgt_ManageBusinessRelationships: [privateDashBoardLevel],
  BusinessAccessMgt_BusinessRelationshipDetails: [privateDashBoardLevel, manageBusinessRelationshipsLevel],
  BusinessAccessMgt_BusinessModifyRelationship: [privateDashBoardLevel, manageBusinessRelationshipsLevel],
  BusinessAccessMgt_ReceivedRequestsDetails: [privateDashBoardLevel, manageBusinessReceivedRequestsLevel],
  BusinessAccessMgt_SentRequestsDetails: [privateDashBoardLevel, manageBusinessSentRequestsLevel],
  BusinessAccessMgt_CreateB2BRequest: [privateDashBoardLevel, manageBusinessRelationshipsLevel],
  BusinessAccessMgt_CreateRelationshipRequest: [privateDashBoardLevel, manageBusinessRelationshipsLevel],
  BusinessAccessMgt_B2BApprovalRequest: [privateDashBoardLevel, manageBusinessRelationshipsLevel],
  BusinessAccessMgt_B2BRejectRequest: [privateDashBoardLevel, manageBusinessReceivedRequestsLevel],


  // Employees / User requests
  EmployeeAccessMgt_ManageEmployees: [privateDashBoardLevel],
  EmployeeAccessMgt_AccessRequestDetails: [privateDashBoardLevel, manageUserRequestsLevel],
  EmployeeAccessMgt_AccessRequestReject: [privateDashBoardLevel, manageUserRequestsLevel],
  EmployeeAccessMgt_SelectAccessRequests: [privateDashBoardLevel, manageUserRequestsLevel],
  EmployeeAccessMgt_ConfirmAccessRequests: [privateDashBoardLevel, manageUserRequestsLevel],
  EmployeeAccessMgt_SelectAccessEmployees: [privateDashBoardLevel, manageEmployeesLevel],
  EmployeeAccessMgt_ConfirmAccessEmployees: [privateDashBoardLevel, manageEmployeesLevel],
  EmployeeAccessMgt_EmployeeDetails: [privateDashBoardLevel, manageEmployeesLevel],
  EmployeeAccessMgt_EmployeeRemove: [privateDashBoardLevel, manageEmployeesLevel],

  // View API Key
  ViewAPIKey: [privateDashBoardLevel],

  // Client Groups
  ClientGroupMgt_ClientGroups: [privateDashBoardLevel],
  ClientGroupMgt_Delete: [privateDashBoardLevel, manageClientGroupsLevel],
  ClientGroupMgt_ClientGroups_Edit: [privateDashBoardLevel, manageClientGroupsLevel],
  ClientGroupMgt_Employees_Edit: [privateDashBoardLevel, manageClientGroupsLevel],

  // Accounts and profiles
  AccountsProfilesMgt_Main: [privateDashBoardLevel, accountsAndProfilesLevel],
  AccountsProfilesMgt_PersonalProfile: [privateDashBoardLevel, accountsAndProfilesLevel],
  AccountsProfilesMgt_ProgramList: [privateDashBoardLevel, accountsAndProfilesLevel],
  AccountsProfilesMgt_ProgramAccountEnrolment: [privateDashBoardLevel, accountsAndProfilesProgramRequestsListLevel],
  AccountsProfilesMgt_ProgramAccountProfile: [privateDashBoardLevel, accountsAndProfilesLevel],
  AccountsProfilesMgt_ProgramAccountProfileAddress: [privateDashBoardLevel, accountsAndProfilesLevel, programAccountAddressLevel],
  AccountsProfilesMgt_ProgramAccountProfileContacts: [privateDashBoardLevel, accountsAndProfilesLevel, programAccountContactsLevel],
  AccountsProfilesMgt_ProgramAccountProfileRequests: [privateDashBoardLevel, accountsAndProfilesLevel, accountsAndProfilesLevelRequests],
  AccountsProfilesMgt_ProgramAccountProfileSubPrograms: [privateDashBoardLevel, accountsAndProfilesLevel, accountsAndProfilesLevelSubPrograms],
  AccountsProfilesMgt_BusinessProfile: [privateDashBoardLevel, accountsAndProfilesLevel],
  AccountsProfilesMgt_BusinessProfileAddress: [privateDashBoardLevel, accountsAndProfilesLevel, accountsAndProfilesAddressLevel],
  AccountsProfilesMgt_BusinessProfileContacts: [privateDashBoardLevel, accountsAndProfilesLevel, accountsAndProfilesContactsLevel],

  // Cbsa Enrolments
  CbsaEnrolmentdMgt_Main: [privateDashBoardLevel],

  // Program Licences
  ProgramLicences_Main: [privateDashBoardLevel, programLicencesLevel],

  // Notifications
  Notifications_List: [privateDashBoardLevel],
  Notifications_Details: [privateDashBoardLevel, notificationListLevel],

  // Rulings
  Rulings: [privateDashBoardLevel],
  Rulings_Requests: [privateDashBoardLevel, rulingsLevel],
  Rulings_EnforcementActions: [privateDashBoardLevel, rulingsLevel],
  Rulings_DisenrolmentAndCompliance: [privateDashBoardLevel, rulingsLevel],
  Rulings_Appeals: [privateDashBoardLevel, rulingsLevel],

  // Documents Upload
  DocumentsUpload_Confirm: [privateDashBoardLevel],
  DocumentsUpload_Step1: [privateDashBoardLevel],
  DocumentsUpload_Step2: [privateDashBoardLevel],

  // Link Business
  LinkBusiness_Requirements: [privateDashBoardLevel],
  LinkBusiness_ValidateNumber: [privateDashBoardLevel, linkBusinessRequirementsLevel],
  LinkBusiness_ValidateName: [privateDashBoardLevel, linkBusinessNumberLevel],
  LinkBusiness_ValidateTransactions: [privateDashBoardLevel, linkBusinessNameLevel],
  LinkBusiness_Review: [privateDashBoardLevel, linkBusinessTransactionLevel],

  // BR & PE
  BusinessRegistration_LinkBusinessSuccessful: [privateDashBoardLevel],

  // Financial Information
  Financial_Main: [privateDashBoardLevel, financialLevel],
  Financial_TransactionHistory: [privateDashBoardLevel, financialLevel, transactionHistoryLevel],
  Financial_FinancialSecurity: [privateDashBoardLevel, financialLevel, financialSecurityLevel],
  Financial_PaymentReceipt: [privateDashBoardLevel, financialLevel],

  // Payments
  Payments_Main: [privateDashBoardLevel, paymentsLevel],
  Payments_OnlinePayments: [privateDashBoardLevel, paymentsLevel, onlinePaymentsLevel],
  Payments_AgreementHistory: [privateDashBoardLevel, paymentsLevel, preAuthorizedDebitLevel],
  Payments_ApplyCredits: [privateDashBoardLevel, paymentsLevel],
  Payments_Confirmation: [privateDashBoardLevel, paymentsLevel],
  Payments_PreAuthorizedDebit: [privateDashBoardLevel, paymentsLevel, preAuthorizedDebitLevel],
  Payments_Arrangement_Main: [privateDashBoardLevel, paymentsLevel, paymentArrangementLevel],
  Payments_FinancialSecurity: [privateDashBoardLevel, financialLevel, financialSecurityLevel],

  // Business Registration
  BusinessRegistration_Main: [businessRegistrationFirstTimeSetup],
  BusinessRegistration_Status: [businessRegistrationStatusLevel],
  Bn9_Registration: [businessRegistrationStatusLevel],

  // Declarations breadcrumbs
  Declarations: [privateDashBoardLevel, declarationsLevel],
  Declarations_New: [privateDashBoardLevel, declarationsLevel, createDeclarationsLevel],
  Declarations_Convert: [privateDashBoardLevel, declarationsLevel, convertDeclarationsLevel],
  Declarations_ListSubmitted: [privateDashBoardLevel, declarationsLevel, declarationsListSubmittedLevel],
  Declarations_ListSubmitted_Drafts: [privateDashBoardLevel, declarationsLevel, declarationsListSubmittedDraftsLevel],
  Declarations_ListROI: [privateDashBoardLevel, declarationsListSubmittedLevel],

  // Dutydrawbacks
  Dutydrawbacks_Main: [privateDashBoardLevel, declarationsLevel, declarationsDrawbackListSubmittedLevel],
  Dutydrawbacks_Exporter: [privateDashBoardLevel, declarationsLevel, dutyDrawbacksEXPLevel],
  Dutydrawbacks_Summary: [privateDashBoardLevel, declarationsLevel, sdaLevel],

  // Temporary Importation
  TemporaryImportations_Main: [privateDashBoardLevel, declarationsLevel, declarationsTempListSubmittedLevel],
  TemporaryImportations_Update: [privateDashBoardLevel, declarationsLevel, declarationsTempListSubmittedLevel],
  TemporaryImportations_Draft: [privateDashBoardLevel, declarationsLevel, createTempImportLevel],

  // Pre-Carm Duty Dutydrawbacks
  PreCarmDutyDrawbacks_NewOrEdit: [privateDashBoardLevel, declarationsLevel],

  // Mass adjustments
  MassAdjustments_Main: [privateDashBoardLevel, declarationsLevel, massAdjustmentsListSubmittedLevel],
  MassAdjustments_NewOrEdit: [privateDashBoardLevel, declarationsLevel, massAdjustmentsLevel, massAdjustmentsNewOrEditLevel],

  // Master provisional
  MasterProvisional_Summary: [privateDashBoardLevel, declarationsLevel, createMasterProvisionalLevel],

  ROI_Main: [privateDashBoardLevel, declarationsLevel, ROIListSubmittedLevel],

  CAD_ConvertB3: [privateDashBoardLevel, declarationsLevel],

  DocumentEnrolmentsCbsaPrograms: [privateDashBoardLevel, accountsAndProfilesProgramRequestsListLevel],
  DocumentEnrolmentsSubPrograms: [privateDashBoardLevel, accountsAndProfilesLevelSubPrograms],
  DocumentEnrolmentsRequests: [privateDashBoardLevel, accountsAndProfilesLevelRequests]
};
